import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { OverviewQuestionnaireItem } from './questionnaire'

export const OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [OverviewQuestionnaireItem.RESUMPTION_OVERVIEW_OVERVIEW_ROC_DATE]:
    QuestionnaireAnswerType.DATE_TIME,
  [OverviewQuestionnaireItem.RESUMPTION_OVERVIEW_OVERVIEW_INPATIENT_DISCHARGE_DATE]:
    QuestionnaireAnswerType.DATE,
  [OverviewQuestionnaireItem.RESUMPTION_OVERVIEW_OVERVIEW_REASON_FOR_INPATIENT_STAY]:
    QuestionnaireAnswerType.STRING,
  [OverviewQuestionnaireItem.RESUMPTION_OVERVIEW_OVERVIEW_INPATIENT_DISCHARGE_INSTRUCTIONS]:
    QuestionnaireAnswerType.STRING,
  [OverviewQuestionnaireItem.RESUMPTION_OVERVIEW_OVERVIEW_COMMENTS]: QuestionnaireAnswerType.STRING
}
